<template>
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.3282 59.8629C46.6671 59.8629 59.9124 46.6176 59.9124 30.2787C59.9124 13.9399 46.6671 0.69458 30.3282 0.69458C13.9894 0.69458 0.74408 13.9399 0.74408 30.2787C0.74408 46.6176 13.9894 59.8629 30.3282 59.8629Z"
      fill="#6048FD"
    />
    <path
      opacity="0.1"
      d="M53.0433 11.3412C47.9262 7.13163 41.3794 4.60138 34.2425 4.60138C17.9038 4.60138 4.65133 17.8539 4.65133 34.1926C4.65133 41.3295 7.18159 47.8763 11.391 52.9934C4.88947 47.57 0.748199 39.412 0.748199 30.2781C0.748199 13.9392 13.9894 0.698242 30.3281 0.698242C39.4619 0.698242 47.62 4.83951 53.0433 11.3412Z"
      fill="black"
    />
  </svg>
</template>
